import { GetterTree } from 'vuex';
import { RootState } from '@/store';
import { DocumentState } from '@/store/modules/document/index';
import { Document, Documents, MissingDocument } from '@/models/form/Documents.model';
import {
  DOCUMENTS,
  DOCUMENTS_ERRORS,
  DOCUMENTS_LIST,
  LOADING,
  MISSING_DOCUMENTS,
  REMOVE_MISSING_DOCUMENT_FLAG,
} from '@/types/documents.types';

export const getters: GetterTree<DocumentState, RootState> = {

  [DOCUMENTS](state): Documents {
    return state.documents;
  },

  [MISSING_DOCUMENTS](state): MissingDocument[] {
    return state.missingDocuments;
  },

  [LOADING](state): boolean {
    return state.loadingMode;
  },

  [REMOVE_MISSING_DOCUMENT_FLAG](state): boolean {
    return state.removeMissingDocumentsFlag;
  },

  [DOCUMENTS_ERRORS](state): string [] {
    return state.documentsErrors;
  },

  [DOCUMENTS_LIST](state): Document [] {
    return [
      ...state.documents.employeeFiles,
      ...state.documents.childrenFiles,
      ...state.documents.extraIncomeFiles,
      ...state.documents.handicapFiles,
      ...state.documents.handicapMonthlyAllowanceFiles,
      ...state.documents.settlementFiles,
      ...state.documents.immigrantFiles,
      ...state.documents.unemployedPartnerFiles,
      ...state.documents.nonCustodyFiles,
      ...state.documents.childSupportFiles,
      ...state.documents.incompetentChildFiles,
      ...state.documents.soldierFiles,
      ...state.documents.academicFiles,
      ...state.documents.reserveFiles,
      ...state.documents.taxCoordsNoIncomeFiles,
      ...state.documents.taxCoordsApprovedFiles,
      ...state.documents.taxCoordsExternalIncomeFiles,
    ];
  },

};
